<template>
  <v-menu v-model="dialog.open" top
    :close-on-content-click="false">
    <v-btn flat color="primary" round @click.native="openDialog" slot="activator">Change Password</v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">{{title}}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container grid-list-md class="pa-0">
            <v-layout row wrap>
              <v-flex sm6>
                <v-text-field
                  v-model="change.currentPassword"
                  :rules="rules.isRequired"
                  label="Current Password"
                  type="password"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex sm6></v-flex>
              <v-flex sm6>
                <v-text-field
                  v-model="change.newPassword"
                  :rules="rules.isRequired"
                  label="New Password"
                  type="password"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  v-model="confirmPassword"
                  :rules="rules.isRequired"
                  label="Confirm New Password"
                  type="password"
                  requiredf
                ></v-text-field>
              </v-flex>
              <v-flex sm3 v-show="confirmPassword.length>0">
                <span v-if="change.newPassword === confirmPassword" class="primary--text">Password Match</span>
                <span v-else class="error--text">Password doesn't match</span>
              </v-flex>
            </v-layout>
          </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outline round @click.native="dialog.open = false">Close</v-btn>
          <v-btn color="primary" round :disabled="!valid" @click="submit">submit</v-btn>
        </v-card-actions>
      </v-card>
  </v-menu>
</template>
<script>
/* globals Store */
import { Password } from '@/models'
export default {
  data () {
    return {
      dialog: {
        open: false
      },
      valid: true,
      change: new Password(Store.state.user.user.email),
      confirmPassword: '',
      rules: {
        isRequired: [
          v => !!v || 'This field is required'
        ]
      }
    }
  },
  computed: {
    title () {
      return 'Change Password'
    }
  },
  methods: {
    openDialog () {
      this.change = new Password(Store.state.user.user.email)
    },
    submit () {
      if (this.$refs.form.validate() && this.change.newPassword === this.confirmPassword) {
          // Native form submission is not yet supported
        Store.dispatch('user/changePassword', this.change)
        this.dialog.open = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ChangePasswordCard.vue